var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('employees-payslip',{attrs:{"print":"","employee":_vm.$route.params.uuid,"term":_vm.$route.params.term}})}
var staticRenderFns = []

export { render, staticRenderFns }